export default "__VITE_ASSET__9q5rXuvN__"